import { Navigation } from "../../interfaces/Navigation";
import { PermissionMenuName } from "../../interfaces/UserRole";

const navPartner: Navigation = {
  title: 'Partner',
  items: [
    {
      title: "Partner",
      route: "/partner",
      icon: "fa fa-handshake-o",
      permissionId: PermissionMenuName.partner
    }
  ]
};

export default navPartner;